import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';

@Component({
	selector: 'app-dynamic-radio-group',
	templateUrl: './dynamic-radio-group.component.html',
	styleUrls: ['./dynamic-radio-group.component.scss'],
	viewProviders: [
		{ provide: ControlContainer, useExisting: FormGroupDirective }
	]
})
export class DynamicRadioGroupComponent {
	@Input() field: any;
	@Output() selectionChanged: EventEmitter<string> = new EventEmitter<string>();

	selectedOption: string;

	constructor(public controlContainer: ControlContainer) {}

	onSelectionChange() {
		this.selectionChanged.emit(this.selectedOption);
	}
}
